import React, { useState, useContext } from 'react';
import ItemList from './items/ItemLIst';
import CategoryList from './categories/CategoryList';
import ContactList from './contact/ContactList';
import InvoiceList from './Invoice/InvoiceList';
import SettingForm from './setting/SettingForm';
import AccountList from './accounts/AccountList';
import TransactionList from './transactions/TransactionList';
import Dashboard from './dash/Dashboard';
import Reports from './reports/Reports';
import { MdHelpOutline } from "react-icons/md";
import ActivationLicense from './license/ActivationLicense';
import { SettingsContext } from './Context/SettingContext';

const Tab = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { settings, loading } = useContext(SettingsContext);

  const hasActivationLicense = localStorage.getItem('dac_activation_license') === 'true';


  const tabs = [
    { label: 'Dashboard' },
    { label: 'Items' },
    { label: 'Categories' },
    { label: 'Contacts' },
    { label: 'Invoices' },
    { label: 'Accounts' },
    { label: 'Transactions' },
    { label: 'Settings' },
    { label: 'Reports' },
  ];



  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const renderTabContent = (tabIndex) => {
    switch (tabs[tabIndex].label) {
      case 'Dashboard':
        return <Dashboard />;
      case 'Items':
        return <ItemList refresh={true} tab={false} />;
      case 'Categories':
        return <CategoryList refresh={true} />;
      case 'Contacts':
        return <ContactList refresh={true} />;
      case 'Invoices':
        return <InvoiceList refresh={true} />;
      case 'Accounts':
        return <AccountList refresh={true} />;
      case 'Transactions':
        return <TransactionList refresh={true} />;
      case 'Settings':
        return <SettingForm />;
      case 'Reports':
        return <Reports />;
      default:
        return (
          <p className="text-gray-500 dark:text-gray-400 text-sm">
            This is some placeholder content for the{' '}
            <strong className="font-medium text-gray-800 dark:text-white">
              {tabs[tabIndex].label} tab's associated content
            </strong>.
          </p>
        );
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <div className="bg-white text-black border-b shadow-sm -ml-5">
        <div className="max-w-[1420px] mx-auto flex justify-between items-center px-4 py-7">
          <div className="text-black">
            <h2 className='text-xl font-semibold pl-3 font-gugi inline mr-2'>Devs Accounting</h2>
            <span className='text-xs'>
              <a target='_blank' href='https://devsbrain.com/'>
                By Devsbrain
              </a>
            </span>
          </div>
          <a className='flex items-center gap-1 text-sm' target='_blank' href='https://devsbrain.com/'>
            <MdHelpOutline size={15} /> Help
          </a>
        </div>
      </div>

      <div className="max-w-[1420px] mx-auto border-gray-200 dark:border-gray-700 p-4">
        <ul className="flex flex-wrap gap-4 -mb-px border-b" id="myTab" data-tabs-toggle="#myTabContent" role="tablist">
          {tabs.map((tab, index) => (
            <li className="mr-2 mb-0" key={index} role="presentation">
              <button
                className={`inline-block text-gray-500 hover:text-gray-600 hover:border-gray-300 rounded-t-lg py-4 text-sm font-medium text-start
                  ${activeTab === index ? 'border-b-[3px] border-blue-500 text-blue-600' : 'border-transparent'}
                  dark:text-gray-400 dark:hover:text-gray-300`}
                id={`${tab.label.toLowerCase()}-tab`}
                data-tabs-target={`#${tab.label.toLowerCase()}`}
                type="button"
                role="tab"
                aria-controls={tab.label.toLowerCase()}
                aria-selected={activeTab === index}
                onClick={() => handleTabClick(index)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      <div id="myTabContent" className='max-w-[1420px] mx-auto'>
        {tabs.map((tab, index) => (
          <div
            key={index}
            className={`px-4 py-2 rounded-lg dark:bg-gray-800 ${activeTab === index ? '' : 'hidden'}`}
            id={tab.label.toLowerCase()}
            role="tabpanel"
            aria-labelledby={`${tab.label.toLowerCase()}-tab`}
          >
            {renderTabContent(index)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tab;
